import React from "react";
import "./HomePage.css";

const HomePage = () => {
  return (
    <div className="home-page">
      <h1>Welcome to PDF Assistant</h1>
      <div className="options">
        <div className="option">
          <h2>Convert PDF</h2>
          <p>
            If your PDF is image-based and not selectable text, convert it here
            before generating the summary.
          </p>
          <a
            href="https://ocr.haidersajjad.site"
            // target="#"
            rel="noopener noreferrer"
          >
            Go to OCR Tool
          </a>
        </div>
        <div className="option">
          <h2>Generate Summary</h2>
          <p>
            If your PDF is already text-based and selectable, generate the
            summary here.
          </p>
          <a href="/upload">Go to PDF Upload</a>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
